export default __webpack_public_path__ + "static/media/Foil_grandilastre_1920x1280.36fc5b50.mp4";